import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  bold: {
    fontWeight: 600,
    color: 'black'
  }
});
